<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.DASHBOARD.SETTINGS')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t('$vuetify.DASHBOARD.SETTINGS_DESCRIPTION'),
          disabled: true
        }
      ]"
    />
    <v-list class="list">
      <template v-for="page in subpages">
        <v-row :key="page.name">
          <v-icon class="pa-2" v-text="page.icon" />
          <a style="color: #007CAD;" class="pa-2" :href="page.to">{{
            page.name
          }}</a>
        </v-row>
      </template>
    </v-list>
  </v-container>
</template>

<script>
export default {
  name: 'Settings',
  data() {
    return {
      subpages: [
        {
          icon: 'mdi-wrench',
          name: this.$vuetify.lang.t('$vuetify.SETTINGS.OPERATOR_SETTINGS'),
          to: '/settings/operator'
        }
      ]
    }
  }
}
</script>

<style scoped>
.list {
  background: transparent;
}
</style>
